import moment from 'moment-timezone';

export class ContractPerformanceBudget {
	public date: Date;
	public volumeDisplay: number;
	public supplyRateDisplay: number;
	public supplyCost: number;
	public delivery: number;
	public totalTaxCost: number;
	public total: number;

	constructor(contractPerformanceBudget?: ContractPerformanceBudget) {
		Object.assign(this, contractPerformanceBudget);

		this.date = this.date ? new Date(moment(this.date).format('MMM DD, YYYY hh:mm:ss a')) : this.date;
	}
}
